var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{attrs:{"title":"Vertical Space","element":_vm.element}},[_c('e-name',{attrs:{"element":_vm.element}}),_c('e-space',{staticClass:"mt-4",attrs:{"element":_vm.element}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }